<!--
  新增流程活动
-->
<template>
  <div class="SubWebPage" v-loading.fullscreen.lock="fullscreenLoading">
    <el-form :model="ruleForm" ref="ruleForm" label-width="90px">
      <el-card class="box-card">
        <div slot="header" class="card-header">
          <h3 class="card-title titleCont">
            <span class="spIcon"></span>
            查看
          </h3>
        </div>
        <div class="card-body">

          <div class="row">
            <div class="col-lg-3 colInfo">
              <label>学期</label>
              <div class="colFonts">{{ruleForm.semester | flNoValue}}</div>
            </div>
            <div class="col-lg-3 colInfo">
              <label>班级</label>
              <div class="colFonts">{{ruleForm.class | flNoValue}}</div>
            </div>
            <div class="col-lg-3 colInfo">
              <label>第几周</label>
              <div class="colFonts">{{ruleForm.week | flNoValue}}</div>
            </div>
            <div class="col-lg-3 colInfo">
              <label>星期几</label>
              <div class="colFonts">{{ruleForm.dayOfWeek | flNoValue}}</div>
            </div>
            <div class="col-lg-3 colInfo">
              <label>课节</label>
              <div class="colFonts">{{'第'+ruleForm.schedule+'节' | flNoValue}}</div>
            </div>
            <div class="col-lg-3 colInfo">
              <label>节数</label>
              <div class="colFonts">{{'共用'+ruleForm.duration+'节' | flNoValue}}</div>
            </div>
          </div>


        </div>
      </el-card>

      <el-card class="box-card">
        <div slot="header" class="card-header">
          <h3 class="card-title titleCont">
            <span class="spIcon"></span>
            班会课题
          </h3>
        </div>
        <div class="card-body">
          <div class="colRemarksCont" v-html="ruleForm.topic"></div>
        </div>
      </el-card>

      <el-card class="box-card">
        <div slot="header" class="card-header">
          <h3 class="card-title titleCont">
            <span class="spIcon"></span>
            本课目的
          </h3>
        </div>
        <div class="card-body">
          <div class="colRemarksCont" v-html="ruleForm.objective"></div>
        </div>
      </el-card>

      <el-card class="box-card">
        <div slot="header" class="card-header">
          <h3 class="card-title titleCont">
            <span class="spIcon"></span>
            本课形式
          </h3>
        </div>
        <div class="card-body">
          <div class="colRemarksCont" v-html="ruleForm.form"></div>
        </div>
      </el-card>

      <el-card class="box-card">
        <div slot="header" class="card-header">
          <h3 class="card-title titleCont">
            <span class="spIcon"></span>
            过程设计
          </h3>
        </div>
        <div class="card-body">
          <div class="colRemarksCont" v-html="ruleForm.processDesign"></div>
        </div>
      </el-card>




			<div class="row">
					<div class="col-12">
						<el-button  icon="el-icon-back" @click="onBack()">返回</el-button>
					</div>
			</div>
    </el-form>
  </div>
</template>

<script>
  import '@/assets/css/Admin.css';


  export default {
    components: {

    },
    data() {
      return {
				fullscreenLoading:false,
				ruleForm:{
          meetingId:null,
          semesterId:null,
          classId:null,
          topic:null,//班课课题
          objective:null,//目的
          form:null,//形式
          processDesign:null,//过程设计
          week:null,//第几周
          dayOfWeek:null,
          schedule:null,//第几节课
          duration:null//时长（节课）
				},
      };
    },
		created()
    {
			let that = this;
			let id = that.$route.params.Id;
      that.ruleForm.meetingId=id;
      that.fullscreenLoading=true;
      ajaxGet(that,"/api/admin/adviserclassmeeting/"+id,null,function(res){
        that.ruleForm=res;
        that.fullscreenLoading=false;
      })
      that.fullscreenLoading=true;
		},

		mounted() {
    },
    methods: {
			onBack()
			{
				let that = this;
				back(that);
			},
		},
		watch: {

		},
    filters:{
      flNoValue(obj){
        if (obj == null || typeof(obj) == "undefined" || obj == ''){
          return '暂无数据';
        }
        return obj;
      }
    },
  };







</script>

<style scoped="scoped">

</style>
